const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var Ideal24 = function Ideal24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      fill: "#fff",
      d: "M.77 1.78v20.44c0 .98.802 1.78 1.78 1.78h12.214C23.997 24 28 18.832 28 11.973 28 5.15 23.997 0 14.764 0H2.55C1.572 0 .77.8.77 1.78Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#C06",
      d: "M8.946 5.017v15.105h6.574c5.968 0 8.557-3.372 8.557-8.14 0-4.563-2.589-8.104-8.557-8.104h-5.435a1.14 1.14 0 0 0-1.14 1.139Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#000",
      d: "M14.764 22.372H4.142a1.708 1.708 0 0 1-1.708-1.708V3.344c0-.942.765-1.707 1.708-1.707h10.622c10.078 0 11.581 6.484 11.581 10.345 0 6.698-4.118 10.39-11.581 10.39ZM4.142 2.206c-.631 0-1.138.507-1.138 1.139v17.32c0 .63.507 1.138 1.138 1.138h10.622c7.098 0 11.012-3.487 11.012-9.82 0-8.505-6.903-9.777-11.012-9.777H4.142Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#fff",
      d: "M11.259 9.945c.231 0 .444.036.65.107.204.071.373.187.524.329.142.151.258.338.347.551.08.223.124.48.124.783 0 .267-.035.507-.098.73a1.704 1.704 0 0 1-.302.578 1.47 1.47 0 0 1-.507.382 1.792 1.792 0 0 1-.72.143H9.72V9.936h1.539v.01Zm-.054 2.944c.116 0 .223-.017.338-.053a.663.663 0 0 0 .285-.187c.08-.089.151-.195.205-.338a1.41 1.41 0 0 0 .08-.507 2.06 2.06 0 0 0-.054-.489.974.974 0 0 0-.178-.374.802.802 0 0 0-.32-.24 1.309 1.309 0 0 0-.49-.08h-.568v2.277h.702v-.008ZM16.116 10.612h-1.904v.774h1.752V12h-1.752v.88h1.948v.668h-2.74V9.936h2.696v.676ZM18.838 9.945l1.352 3.612h-.828l-.275-.801h-1.352l-.285.8h-.8l1.36-3.611h.828Zm.044 2.215-.454-1.325h-.009l-.47 1.325h.933ZM21.48 9.945v2.944h1.76v.668h-2.552V9.945h.792Z",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fill: "#000",
      d: "M5.975 13.414a1.663 1.663 0 1 0 0-3.327 1.663 1.663 0 0 0 0 3.327ZM7.229 20.122a2.515 2.515 0 0 1-2.517-2.518v-1.966a1.262 1.262 0 1 1 2.526 0v4.484h-.009Z",
    })
  );
};
Ideal24.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "28",
  height: "24",
  fill: "none",
  viewBox: "0 0 28 24",
};
var Ideal32 = function Ideal32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("rect", {
      x: ".5",
      y: ".5",
      width: "31",
      height: "23",
      rx: "3.5",
      fill: "#fff",
      stroke: "#CCC",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M16.82 20.68H7.95c-.79 0-1.43-.64-1.43-1.43V4.8c0-.78.64-1.42 1.43-1.42h8.87c8.41 0 9.66 5.41 9.66 8.63 0 5.6-3.43 8.68-9.66 8.68ZM7.95 3.84A.95.95 0 0 0 7 4.8v14.46c0 .53.42.95.95.95h8.87C22.74 20.2 26 17.3 26 12c0-7.1-5.76-8.16-9.2-8.16H7.96Z",
      fill: "#000",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.96 18.8V6.19c0-.52.42-.95.95-.95h4.54c4.98 0 7.14 2.95 7.14 6.76 0 3.98-2.16 6.8-7.14 6.8h-5.5Zm5.98-8.5v.56h-1.58v.65h1.46v.5h-1.46v.74h1.62v.56H15.7v-3.02h2.25v.01Zm-4.05 0c.2 0 .37.03.54.1.17.05.31.15.44.27.12.12.22.28.29.46a2.24 2.24 0 0 1 .02 1.26c-.06.18-.14.35-.25.48-.11.14-.25.24-.42.32a1.5 1.5 0 0 1-.6.12h-1.3v-3.02h1.28v.01Zm-.04 2.46a.9.9 0 0 0 .28-.04.55.55 0 0 0 .23-.16.87.87 0 0 0 .18-.28 1.72 1.72 0 0 0 .02-.83.81.81 0 0 0-.15-.32.67.67 0 0 0-.27-.2 1.1 1.1 0 0 0-.4-.06h-.48v1.9h.59v-.01Zm7.5.56-1.13-3.02h-.7l-1.13 3.02h.67l.24-.67h1.12l.23.67h.7Zm-1.48-2.28.38 1.11h-.78l.4-1.1Zm2.55-.74v2.46h1.47v.56h-2.13V10.3h.66Z",
      fill: "#C06",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.87 11.81a1.39 1.39 0 1 1-2.78 0 1.39 1.39 0 0 1 2.78 0ZM8.42 16.7c0 1.15.94 2.1 2.1 2.1h.01v-3.75a1.05 1.05 0 1 0-2.1 0v1.65Z",
      fill: "#000",
    })
  );
};
Ideal32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  24: Ideal24,
  32: Ideal32,
};
export function Ideal(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'Ideal' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
